<template>
  <div class="funnels-item">
    <!-- todo: i18n test ui -->
    <div class="funnels__text--wrap">
      <div class="text-step--wrap">
        <h4 class="title">Step {{ itemIndex + 1 }}</h4>
        <span class="txt--desc">{{ item.name }}</span>
        <ui-tooltip class="stop-alert" arrowTop arrowCenter noApplyCenterAnimate v-show="item.state === 'stop'">
          <span class="icon icon--stop"></span>
          {{ $t('funnel.funnelsItem.stopDataCollection.tooltip') }}
        </ui-tooltip>
      </div>
      <div class="step__info--wrap clearfix">
        <div class="img_thumb" :style="thumbImageStyle"></div>
        <div class="info_data">
          <span class="badge_icon" v-if="isLastItem">
            {{ $t('funnel.funnelsItem.conversionRate') }}
          </span>
          <span class="txt_percent">{{ remain === 100 ? 100 : parseFloat(remain).toFixed(1) }} <span class="txt_item">%</span></span>
          <span class="txt_num">{{ inflow | thousand }}
            <span class="txt_desc">{{ $tc('common.sessions', inflow) }}</span>
          </span>
          <ui-button
            class="link_share"
            :iconName="'icon--share'"
            @click.prevent="onShowFlowClick(item)">
            {{ $t('funnel.funnelsItem.userBehavior') }}
          </ui-button>
        </div>
      </div>
    </div>
    <div class="box--data__wrap">
      <template v-if="sessionCount">
        <span class="box--wrap" v-if="pathItem.newPath"
          :style="newPercentageStyle">{{ item.newPercentage | fixed(1) }}%</span>
        <span class="box--wrap box--wrap_type2" v-if="pathItem.revisitPath"
          :style="revisitPercentageStyle">{{ item.revisitPercentage | fixed(1) }}%</span>
      </template>
      <svg width="100%" height="250" viewBox="0 0 100 100" preserveAspectRatio="none">
        <path v-if="pathItem.newPath" :d="pathItem.newPath" fill="#9fce12"/>
        <path v-if="pathItem.revisitPath" :d="pathItem.revisitPath" fill="#1199af"/>
        <path d="M 100 0 L 100 100" class="vline"/>
      </svg>
    </div>
    <div class="view__info--wrap">
      <div class="info__wrap">
        <ui-button
          v-if="isLastItem"
          :class="{ disable: !isExactMatchType }"
          :iconName="'icon--converted'"
          @click.prevent="onConversionClick(item, true, true)"
          class="link_info link_converted">
          {{ $t('common.converted') }}
        </ui-button>

        <template v-else>
          <a href="#none" class="link_info" :class="{ disable: !isExactMatchType }"
            @click.prevent="onConversionClick(item, false, false)">
            {{ $t('common.inflow') }}
          </a>
          <a href="#none" class="link_info" :class="{ disable: !isExactMatchType }"
            @click.prevent="onConversionClick(item, true, false)">
            {{ $t('common.dropped') }}
          </a>
        </template>
      </div>
      <div class="status--wrap" v-if="!isLastItem">
        <span class="status_icon" :class="dropOffIconClass"></span>
        <span class="status_desc">{{ $t('common.dropOff') }}</span>
        <span class="status_num">{{ dropOffRate | fixed(1) }}%</span>
        <span class="status_total">{{ dropped | thousand }}
          <span class="status_add">({{ $tc('common.sessions', dropped) }})</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import FunnelsItemMixin from './FunnelsItemMixin'
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'FunnelsItemTypeA',
  components: {
    UiButton
  },
  mixins: [
    FunnelsItemMixin
  ]
}
</script>

<style>

</style>
